(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("esprima"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["esprima"], factory);
	else if(typeof exports === 'object')
		exports["SwaggerUIStandalonePreset"] = factory((function webpackLoadOptionalExternalModule() { try { return require("esprima"); } catch(e) {} }()));
	else
		root["SwaggerUIStandalonePreset"] = factory(root["esprima"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__160__) {
return 